import React from 'react'
import './NotFoundPage.style.css'
const NotFoundPage = () => {
    return (
        <div className="NotPage">
            <h1>Not Found Page 😭</h1>
            <h2>ERROR 404</h2>
        </div>
    )
}

export default NotFoundPage